export const tokenTypes = {
  extendedTableCellRowspanMarker: 'extendedTableCellRowspanMarker',
  extendedTableCellColspanMarker: 'extendedTableCellColspanMarker'
};